import { Controller } from 'react-hook-form';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
  UncontrolledAlert,
} from 'reactstrap';

import AdminPage from '../../components/admin/AdminPage';
import { useState } from 'react';
import useCustomer from './hooks/useCustomer';
import Select from 'react-select';

const CustomerCreate = () => {
  const pageName = 'Crear nuevo usuario';
  const pageParentName = 'Usuarios';
  const [errorAlert, setErrorAlert] = useState(null);
  const globalAlertOptions = {
    success: false,
    warning: true,
    onConfirm: () => setErrorAlert(null),
    title: 'Error',
    text: errorAlert || '',
  };

  const {
    handleSubmit,
    doCreate,
    error,
    control,
    errors,
    propersOptions,
    setValue,
    isLoading,
    phone_config,
    areaCodes,
    resetField,
    documentOptions,
  } = useCustomer();

  const [phoneLength, setPhoneLength] = useState<number>(
    phone_config?.phone_length ?? 0,
  );

  return (
    <>
      <AdminPage
        name={pageName}
        parentName={pageParentName}
        globalAlertOptions={globalAlertOptions}
      >
        <Row>
          <div className="col">
            <Card>
              <Form role="form" onSubmit={handleSubmit(doCreate)}>
                <CardBody>
                  <Col md="6">
                    {/* first_name */}
                    <Row>
                      <Col md="12">
                        {error && (
                          <UncontrolledAlert color="danger" fade={false}>
                            <span className="alert-inner--text">
                              <strong> Ops! </strong>
                              {error}
                            </span>
                          </UncontrolledAlert>
                        )}
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="first_name"
                          >
                            Nombres
                          </label>
                          <Controller
                            name="first_name"
                            control={control}
                            defaultValue={''}
                            render={({ field }) => (
                              <Input
                                className={
                                  errors.first_name?.message && 'is-invalid'
                                }
                                {...field}
                                id="first_name"
                              />
                            )}
                          />
                          <h5 className="text-danger">
                            {errors.first_name?.message}
                          </h5>
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* last_name */}
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="last_name"
                          >
                            Apellidos
                          </label>
                          <Controller
                            name="last_name"
                            control={control}
                            defaultValue={''}
                            render={({ field }) => (
                              <Input
                                className={
                                  errors.last_name?.message && 'is-invalid'
                                }
                                {...field}
                                id="last_name"
                              />
                            )}
                          />
                          <h5 className="text-danger">
                            {errors.last_name?.message}
                          </h5>
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* email */}
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="email">
                            Correo electrónico
                          </label>
                          <Controller
                            name="email"
                            control={control}
                            defaultValue={''}
                            render={({ field }) => (
                              <Input
                                className={
                                  errors.email?.message && 'is-invalid'
                                }
                                {...field}
                                id="email"
                              />
                            )}
                          />
                          <h5 className="text-danger">
                            {errors.email?.message}
                          </h5>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="phone">
                            Teléfono
                          </label>
                          <div
                            style={{
                              display: 'flex',
                              gap: 8,
                              alignItems: 'center',
                            }}
                          >
                            <Controller
                              name="area_code"
                              control={control}
                              defaultValue={''}
                              render={({ field }) => {
                                const options = areaCodes.map((c) => ({
                                  value: c.phone_area_code,
                                  label: `${c.code} - ${c.phone_area_code}`,
                                  phone_length: c.phone_length ?? 0,
                                }));
                                const selectedOption =
                                  options.find(
                                    (option) => option.value === field.value,
                                  ) || null;
                                return (
                                  <div
                                    style={{
                                      minWidth: 120,
                                      maxWidth: 200,
                                      flex: '0 0 140px',
                                    }}
                                  >
                                    <Select<
                                      {
                                        value: string;
                                        label: string;
                                        phone_length: number;
                                      },
                                      false
                                    >
                                      options={options}
                                      value={selectedOption}
                                      placeholder="Código"
                                      isClearable
                                      onChange={(option) => {
                                        resetField('phone');
                                        field.onChange(
                                          option ? option.value : '',
                                        );
                                        setPhoneLength(
                                          option?.phone_length ?? 0,
                                        );
                                      }}
                                      styles={{
                                        container: (base) => ({
                                          ...base,
                                          minWidth: 120,
                                          maxWidth: 200,
                                          flex: 1,
                                        }),
                                        control: (base) => ({
                                          ...base,
                                          minHeight: 38,
                                          fontSize: 15,
                                          paddingLeft: 2,
                                          paddingRight: 2,
                                        }),
                                        valueContainer: (base) => ({
                                          ...base,
                                          padding: '0 6px',
                                        }),
                                        input: (base) => ({
                                          ...base,
                                          margin: 0,
                                          padding: 0,
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: 140,
                                        }),
                                      }}
                                      onBlur={field.onBlur}
                                      name={field.name}
                                      ref={field.ref}
                                    />
                                  </div>
                                );
                              }}
                            />
                            <Controller
                              name="phone"
                              control={control}
                              defaultValue={''}
                              render={({ field: phoneField }) => (
                                <Input
                                  className={
                                    errors.phone?.message && 'is-invalid'
                                  }
                                  {...phoneField}
                                  maxLength={phoneLength}
                                  id="phone"
                                  placeholder="Teléfono"
                                  style={{ flex: 1, minWidth: 0 }}
                                />
                              )}
                            />
                          </div>
                          <h5 className="text-danger">
                            {errors.phone?.message}
                          </h5>
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* document_type & document_number */}
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="document_number"
                          >
                            Documento de identificación
                          </label>
                          <div
                            style={{
                              display: 'flex',
                              gap: 8,
                              alignItems: 'center',
                            }}
                          >
                            <Controller
                              name="document_type"
                              control={control}
                              defaultValue={''}
                              render={({ field }) => {
                                const selectedOption =
                                  documentOptions.find(
                                    (option) => option.value === field.value,
                                  ) || null;
                                return (
                                  <div
                                    style={{
                                      minWidth: 140,
                                      maxWidth: 220,
                                      flex: '0 0 180px',
                                    }}
                                  >
                                    <Select<{
                                      value: string;
                                      label: string;
                                    }, false>
                                      options={documentOptions}
                                      value={selectedOption}
                                      placeholder="Tipo"
                                      isClearable
                                      onChange={(option) => {
                                        field.onChange(
                                          option ? option.value : '',
                                        );
                                        if (!option) {
                                          resetField('document_number');
                                        }
                                      }}
                                      styles={{
                                        container: (base) => ({
                                          ...base,
                                          minWidth: 140,
                                          maxWidth: 220,
                                          flex: 1,
                                        }),
                                        control: (base) => ({
                                          ...base,
                                          minHeight: 38,
                                          fontSize: 15,
                                          paddingLeft: 2,
                                          paddingRight: 2,
                                        }),
                                        valueContainer: (base) => ({
                                          ...base,
                                          padding: '0 6px',
                                        }),
                                        input: (base) => ({
                                          ...base,
                                          margin: 0,
                                          padding: 0,
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: 160,
                                        }),
                                      }}
                                      onBlur={field.onBlur}
                                      name={field.name}
                                      ref={field.ref}
                                    />
                                  </div>
                                );
                              }}
                            />
                            <Controller
                              name="document_number"
                              control={control}
                              defaultValue={''}
                              render={({ field: docField }) => (
                                <Input
                                  className={
                                    errors.document_number?.message &&
                                    'is-invalid'
                                  }
                                  {...docField}
                                  id="document_number"
                                  placeholder="Número de documento"
                                  style={{ flex: 1, minWidth: 0 }}
                                />
                              )}
                            />
                          </div>
                          <h5 className="text-danger">
                            {errors.document_number?.message ||
                              errors.document_type?.message}
                          </h5>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="proper_id"
                          >
                            Asignar proper
                          </label>
                          <Controller
                            name="proper_id"
                            control={control}
                            render={({ field }) => (
                              <Select
                                placeholder={'Selecciona un proper'}
                                options={propersOptions}
                                onChange={(selected) => {
                                  setValue('proper_id', selected?.value);
                                }}
                                ref={field.ref}
                              />
                            )}
                          />
                          <h5 className="text-danger">
                            {errors.proper_id?.message}
                          </h5>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="6">
                    <Alert color="default">
                      Los usuarios creados en este formulario ya no son
                      representados como inquilino ni propietario por separado,
                      Ahora son usuarios generales que pueden hacer tanto leads
                      de landlord como de tenant, No incluir en este apartado
                      Brokers, si se detectan errores en el formulario
                      notificarlo con el administrador para revisión.
                    </Alert>
                  </Col>
                </CardBody>
                <CardFooter>
                  <Button color={'primary'} disabled={isLoading}>
                    Crear
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </div>
        </Row>
      </AdminPage>
    </>
  );
};

export default CustomerCreate;
